"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["FORM_URL_ENCODED"] = "application/x-www-form-urlencoded; charset=UTF-8";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
